<div class="kiosk-setting-main-wrapper">
	<div class="kiosk-settings-wrapper kiosk-setting-page">
		<div class="kiosk-settings-header">
			<div class="kiosk-settings-title">
				<!-- <div><img [src]="'./assets/Tablet (White).svg' | resolveAsset" alt=""></div> -->
				<span>Kiosk Mode Options</span>
			</div>
		</div>
		<div class="kiosk-settings">
			<div class="kiosk-setting-option">
				<div class="kiosk-settings-info">
					<span class="kiosk-settings-title"> Type in name or email </span>
					<span class="kiosk-settings-description"> Students can create a pass by typing in their name or email.</span>
				</div>
				<div class="kiosk-settings-toggle">
					<app-toggle-input
						[form]="this.form"
						[customClass]="!idSetup"
						customToolTip
						[contentTemplate]="tooltipName"
						controlName="findByName"
						controlSize="small"
						[delimiter]="false"></app-toggle-input>
				</div>
			</div>
			<ng-template #tooltipName>
				<div *ngIf="!idSetup" class="ds-tooltip">
					<p>You must have ID numbers set up to turn this on. Admins can set up ID numbers in integrations.</p>
				</div>
			</ng-template>
			<div class="kiosk-setting-option">
				<div class="kiosk-settings-info">
					<span class="kiosk-settings-title"> Type in ID number </span>
					<span class="kiosk-settings-description"> Students can create a pass by typing in their ID number. </span>
				</div>
				<div class="kiosk-settings-toggle">
					<app-toggle-input
						[form]="this.form"
						[customClass]="!idSetup"
						customToolTip
						[contentTemplate]="tooltipId"
						controlName="findById"
						controlSize="small"
						[delimiter]="false"></app-toggle-input>
				</div>
			</div>
			<ng-template #tooltipId>
				<div *ngIf="!idSetup" class="ds-tooltip">
					<p>You must have ID numbers set up to turn this on. Admins can set up ID numbers in integrations.</p>
				</div>
			</ng-template>
			<div class="kiosk-setting-option">
				<div class="kiosk-settings-info">
					<span class="kiosk-settings-title"> ID Scanning </span>
					<span class="kiosk-settings-description">
						Students can create a pass by scanning their ID.
						<b>You must have a compatible third-party scanner attached to this device. </b>
						<a href="https://www.smartpass.app/kioskmode" target="_blank">Learn more</a>
					</span>
				</div>
				<div class="kiosk-settings-toggle">
					<app-toggle-input
						[customClass]="!idSetup"
						customToolTip
						[contentTemplate]="tooltip"
						[form]="this.form"
						controlName="findByScan"
						controlSize="small"
						[delimiter]="false"></app-toggle-input>
				</div>
			</div>
			<ng-template #tooltip>
				<div *ngIf="!idSetup" class="ds-tooltip">
					<p>You must have ID numbers set up to turn this on. Admins can set up ID numbers in integrations.</p>
				</div>
			</ng-template>
			<div>
				<app-gradient-button
					customToolTip
					[contentTemplate]="tooltipSubmit"
					[disabled]="!validCheck"
					size="editable"
					width="375px"
					minHeight="56px"
					fontSize="14px"
					(buttonClick)="enterKioskMode()">
					<span class="svg-buttob-wrap">
						Enter Kiosk Mode
						<svg
							xmlns="http://www.w3.org/2000/svg"
							version="1.1"
							xmlns:xlink="http://www.w3.org/1999/xlink"
							xmlns:svgjs="http://svgjs.com/svgjs"
							width="15"
							height="15"
							x="0"
							y="0"
							viewBox="0 0 512.002 512.002"
							style="enable-background: new 0 0 512 512"
							xml:space="preserve"
							class="">
							<g>
								<g>
									<g>
										<path
											d="M388.425,241.951L151.609,5.79c-7.759-7.733-20.321-7.72-28.067,0.04c-7.74,7.759-7.72,20.328,0.04,28.067l222.72,222.105
                        L123.574,478.106c-7.759,7.74-7.779,20.301-0.04,28.061c3.883,3.89,8.97,5.835,14.057,5.835c5.074,0,10.141-1.932,14.017-5.795
                        l236.817-236.155c3.737-3.718,5.834-8.778,5.834-14.05S392.156,245.676,388.425,241.951z"
											fill="#ffffff"
											data-original="#000000"
											class=""></path>
									</g>
								</g>
								<g></g>
								<g></g>
								<g></g>
								<g></g>
								<g></g>
								<g></g>
								<g></g>
								<g></g>
								<g></g>
								<g></g>
								<g></g>
								<g></g>
								<g></g>
								<g></g>
								<g></g>
							</g>
						</svg>
					</span>
				</app-gradient-button>
				<ng-template #tooltipSubmit>
					<div *ngIf="!validCheck" class="ds-tooltip">
						<p>You must turn on one of the options to enter kiosk mode</p>
					</div>
				</ng-template>
			</div>
		</div>
	</div>
</div>
